<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-select ttLabel="prodsize_keyno" [(ttModel)]="setting.prodsize_keyno" (ttModelChange)="onChanged($event, 'prodsize_keyno')" [ttData]="selectListProductSizes" ttDataId="item_id" ttDataName="item_name"></tt-select>
        </tt-card>

        <tt-list [ttData]="itemsListProductUnitDatas"></tt-list>

        <tt-card *ngIf="!!example">
            <tt-textarea ttLabel="exampledata" [ttModel]="example.exampledata" ttReadonly></tt-textarea>
        </tt-card>
    </div>

    <div class="col-xs-12 sp-0" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 col-md-4 p-5">
            <tt-card>
                <tt-select ttLabel="prodsize_keyno" [(ttModel)]="setting.prodsize_keyno" (ttModelChange)="onChanged($event, 'prodsize_keyno')" [ttData]="selectListProductSizes" ttDataId="item_id" ttDataName="item_name"></tt-select>
            </tt-card>

            <tt-list [ttData]="itemsListProductUnitDatas"></tt-list>
        </div>

        <tt-card class="col-xs-12 col-md-4 p-5" *ngIf="!!example">
            <tt-textarea ttLabel="exampledata" [ttModel]="example.exampledata" ttReadonly></tt-textarea>
        </tt-card>
    </div>
</tt-page>
